import React from 'react';
import _ from 'lodash';
import { Button, Box, Stack, Typography } from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import store from '../../../../../services/redux-store';

import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { AlertDialogContainer } from '../../../../../components/others/AlertDialogContainer';
import { submitBonusAction } from '../../../../../services/request';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';

export const BonusForm = props => {
  const { data, submitCallback, handleClose } = props;

  const { loading, mutate } = useMutation(submitBonusAction);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

  const state = store.getState();

  const validationSchema = Yup.object({
    name: Yup.string().required('To pole nie może być puste'),
    description: Yup.string().optional(),
    value: Yup.number().required('To pole nie może być puste')
  });
  const initialValues = {
    name: data ? data.name || '' : '',
    description: data ? data.description || '' : '',
    value: data ? data.value || 0 : 0,
    season: data ? data.season : state.app.season
  };

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, data ? 'PUT' : 'POST', data ? data.id : undefined);
    if (!error) {
      submitCallback(payload, data ? 'edit' : 'created', 'success', data ? 'Zaktualizowano imprezę' : 'Dodano nową imprezę', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się ${data ? 'edytować' : 'dodać nowej'} imprezy`);
      setMessage(payload);
      setShowAlert(true);
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', data.id);
    if (!error) {
      submitCallback(data, 'delete', 'success', `Usunięto impreze ${data.name}`, '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się usunąć imprezy ${data.name}`);
      setMessage(payload.toString());
      setShowAlert(true);
    }
  };

  const formik = useFormik({
    enableReinitialize: data ? true : false,
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });


  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
        <Stack direction="row" mt={1} p={1} spacing={2}>
          <Box display="flex" flexDirection="column" flex="1">
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Nazwa</Typography>
              <DebounceInput
                sx={{ flex: '1 1 90%' }}
                name="name"
                id="name"
                type="text"
                placeholder="nazwa bonusu"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Szczegóły</Typography>
              <DebounceInput
                sx={{ flex: '1 1 90%' }}
                name="description"
                id="description"
                type="text"
                placeholder="opis bonusu"
                value={formik.values.description}
                onChange={formik.handleChange}
                error={formik.touched.description && Boolean(formik.errors.description)}
                helperText={formik.touched.description && formik.errors.description}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Wartość</Typography>
              <DebounceInput
                sx={{ flex: '1 1 90%' }}
                name="value"
                id="value"
                type="number"
                placeholder="Wartość bonusu"
                value={formik.values.value}
                onChange={formik.handleChange}
                error={formik.touched.value && Boolean(formik.errors.value)}
                helperText={formik.touched.value && formik.errors.value}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
          </Box>
        </Stack>

        <Button
          color="primary"
          variant="contained"
          type="submit"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          <AddIcon />
          Zapisz
        </Button>
        { data
          ? <Button
            color="error"
            variant="contained"
            sx={{ mt: 3, ml: 4 }}
            onClick={() => {
              setConfirmDeleteOpen(true);
            }}
            disabled={loading}
          >
            <DeleteIcon />
          Usuń
          </Button>
          : null}
      </form>
      <ConfirmDialog
        title="Usunąć bonus?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
        disabled={loading}
      >
        Czy na pewno chcesz usunąć ten bonus?
      </ConfirmDialog>
    </>

  );
};
